import { lazy } from 'react';
import TravelMedicalIcon from 'products/nomad_insurance/assets/img/benefits/travel-medical.svg';
import MedicalEvacIcon from 'products/nomad_insurance/assets/img/benefits/medical-evac.svg';
import HomeCountryCoverageIcon from 'products/nomad_insurance/assets/img/benefits/home-coverage.svg';
import SportsIcon from 'products/nomad_insurance/assets/img/benefits/sports.svg';
import DrivingAccidentIcon from 'products/nomad_insurance/assets/img/benefits/driving-accident.svg';
import LostLuggageIcon from 'products/nomad_insurance/assets/img/benefits/lost-luggage.svg';
import TravelDelayIcon from 'products/nomad_insurance/assets/img/benefits/travel-delay.svg';
import TripInterruptionIcon from 'products/nomad_insurance/assets/img/benefits/trip-interruption.svg';
import EmergencyDentalIcon from 'products/nomad_insurance/assets/img/benefits/dental.svg';
import RepatriationIcon from 'products/nomad_insurance/assets/img/benefits/repatriation.svg';

export const COVERAGE_ITEMS = [
  {
    name: 'Travel\n medical',
    iconSrc: TravelMedicalIcon,
    Info: lazy(() => import('./components/TravelMedical'))
  },
  {
    name: 'Emergency evacuation',
    iconSrc: MedicalEvacIcon,
    Info: lazy(() => import('./components/EmergencyEvacuation'))
  },
  {
    name: 'Home country coverage',
    iconSrc: HomeCountryCoverageIcon,
    Info: lazy(() => import('./components/HomeCountryCoverage'))
  },
  {
    name: 'Sports & activities',
    iconSrc: SportsIcon,
    Info: lazy(() => import('./components/Sports'))
  },
  {
    name: 'Driving\n accidents',
    iconSrc: DrivingAccidentIcon,
    Info: lazy(() => import('./components/DrivingAccidents'))
  },
  {
    name: 'Lost checked luggage',
    iconSrc: LostLuggageIcon,
    Info: lazy(() => import('./components/LostLuggage'))
  },
  {
    name: 'Travel delay',
    iconSrc: TravelDelayIcon,
    Info: lazy(() => import('./components/TravelDelay'))
  },
  {
    name: 'Trip\n interruption',
    iconSrc: TripInterruptionIcon,
    Info: lazy(() => import('./components/TripInterruption'))
  },
  {
    name: 'Emergency dental',
    iconSrc: EmergencyDentalIcon,
    Info: lazy(() => import('./components/Dental'))
  },
  {
    name: 'Repatriation\n of remains',
    iconSrc: RepatriationIcon,
    Info: lazy(() => import('./components/Repatriation'))
  }
];
